import React, { useState, useContext } from "react";
import "./EmailPopup.css";
import { AppContext } from "../../contexts/AppContext";
import { base_url, errorResponseMessage } from "../../shared/const.prop";
import axios from "axios";

const FORM_ACTION =
  "https://docs.google.com/forms/d/e/1FAIpQLSfPp3El_blceSxlJalBrw7MPMwupSi1uy2rAe6iw6-XjiTguw/formResponse";
const EMAIL_ENTRY = "entry.1602682521";

const EmailPopup = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  // 'idle' | 'success' | 'error'
  const [submitState, setSubmitState] = useState('idle');
  const [errorMsg, setErrorMsg] = useState('');
  const appContext = useContext(AppContext);

  const reset = () => {
    setEmail('');
    setSubmitState('idle');
    setErrorMsg('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      appContext.updateLoaderState(true);

      const body = new URLSearchParams();
      body.append(EMAIL_ENTRY, email);
      body.append('submit', 'Submit');

      const res = await fetch(FORM_ACTION, {
        method: 'POST',
        mode: 'no-cors',
        body,
      });

      // With `no-cors`, the response will be opaque. Treat as success if no error thrown.
      console.log('Submitted to Google Form:', {
        url: FORM_ACTION,
        entry: EMAIL_ENTRY,
        email,
        response: res.type, // likely 'opaque'
      });

      setSubmitState('success');
    } catch (e) {
      const msg = errorResponseMessage(e) || 'Something went wrong. Please try again.';
      setErrorMsg(msg);
      setSubmitState('error');
    } finally {
      appContext.updateLoaderState(false);
    }
  };

  if (!isOpen) return null;

  const handleClose = () => {
    // Reset when closing so it shows the form next time it opens
    reset();
    onClose();
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="close-button" onClick={handleClose}>×</button>

        <h2>Show Interest</h2>
        <p>Be the first to experience our skillverse.</p>

        {/* This wrapper keeps the card height steady whether it's the form or the message */}
        <div className="content-body">
          {submitState === 'idle' && (
            <form onSubmit={handleSubmit} className="email-form">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="submit-button">Submit</button>
            </form>
          )}

          {submitState === 'success' && (
            <div className="result-card success">
              <h3>Thanks for showing interest!</h3>
            </div>
          )}

          {submitState === 'error' && (
            <div className="result-card error">
              <h3>Submission failed</h3>
              <p>{errorMsg}</p>
              <div className="actions">
                <button className="primary" onClick={() => setSubmitState('idle')}>Try again</button>
                <button className="secondary" onClick={handleClose}>Close</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmailPopup;
